import { render, staticRenderFns } from "./ReviewExternalKafkaHarvester.vue?vue&type=template&id=3d8560f4&"
import script from "./ReviewExternalKafkaHarvester.vue?vue&type=script&lang=ts&"
export * from "./ReviewExternalKafkaHarvester.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports